<template>
  <div class="score_rule_container">
    <div class="score_rule_box">
      <div class="h2">积分说明</div>
      <div class="rule_list">
        <p>1、新用户注册成功：按次积分，积分值一次性增加100；</p>
        <p>2、每日签到成功：按天积分，积分值加5，满足连续天数增加积分7；</p>
        <p>3、发表评论并通过审核：按天积分，积分值加2，满足连续天数增加积分5；</p>
        <p>4、浏览内容：按天积分，积分值加1，满足连续天数增加积分1；</p>
        <p>5、分享内容：按天积分，积分值加5，满足连续天数增加积分6；</p>
        <p>6、提交报料并审核通过：按次积分，积分值加20；</p>
        <p>7、邀请送积分：按次积分，积分值加100。</p>
        <p>版权合作联系方式</p>
        <p>电话：027-88888888</p>
        <p>邮箱：88888888@hubeidaily.com</p>
        <p>【每条原创文末，含APP、微信等】</p>
        <p>本文著作权归湖北日报新闻客户端所有，未经授权不得转载。</p>
        <p>版权合作：88888888@hubeidaily.com。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ScoreRule",
  data() {
    return {};
  },
  methods: {},
  created() {
    document.title = "积分说明";
  },
};
</script>
<style scoped lang="scss">
.score_rule_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #000;
  *{
    word-break: normal;
    white-space: normal;
    line-height: 24px;
    font-family: '宋体';
  }
  .score_rule_box {
    .h2 {
      padding: 18px 0;
      text-align: center;
      font-size: 18px;
      font-weight: bolder;
    }
    .rule_list {
      p {
        margin: 5px 0;
        text-indent: 2em;
        font-size: 14px;
      }
    }
  }
}
</style>